import React from 'react';
import MarkdownText from 'MarkdownText';

// Card shown after Claim succeeds. Carries `actions` (a list of action
// specs) instead of a single `action`, so the user can pick directions /
// full menu / hours / etc on the same restaurant. The structured value
// also carries `include_station_ids` — aveq-agent reads that and merges
// the named station's spec into the thread's NL context, so subsequent
// free-form queries ("where is it?") reach the restaurant's functions.
export default function TobinRestaurantActionsCard({ structured, onAction }) {
  const actions = structured.actions || [];
  return (
    <div style={{
      marginBottom: '10px', padding: '12px', background: '#fff7ed',
      borderRadius: '8px', border: '1px solid #fed7aa',
    }}>
      <div style={{ fontSize: '0.9rem', fontFamily: '"IBM Plex Mono", monospace', marginBottom: '10px' }}>
        <MarkdownText text={structured.text} />
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {actions.map((action, i) => (
          <button
            key={i}
            onClick={() => onAction(action, structured)}
            style={{
              fontSize: '0.75rem', fontWeight: 700, padding: '4px 12px',
              border: '1px solid #c2410c', borderRadius: '14px',
              background: 'transparent', color: '#c2410c', cursor: 'pointer',
            }}
          >
            {action.label || 'Action'}
          </button>
        ))}
      </div>
    </div>
  );
}
